import i18n from 'services/base/i18n';

export default {
  // Placeholder for the Operating System selection dropdown
  placeholder: () => i18n.pgettext('Components|Select Device OS', 'Select OS'),
  // Placeholder for the input box to search within the dropdown
  search: () => i18n.pgettext('Components|Select Device OS', 'Search'),
};
